<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectPalletExchange" });
import { SelectSingle } from "../../../../selects/index.js";
export let key;
export let isDisabled = false;
export let isRequired = false;
const OPTIONS = [{ key: "available", label: "Yes" }, { key: "unavailable", label: "No" }, { key: "unknown", label: "Unknown" }];
</script>

<SelectSingle
    bind:key
    label = 'Pallet Exchange Possible'
    placeholder = 'Select Option'
    name = 'address.palletExchangeCode'
    options = { OPTIONS }
    { isDisabled }
    { isRequired }
/>